import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import brand from '../../container/image/logo.png'
import './SideDrawerItems.css';
import getNavLinks from './util/SideDrawerNavItems';

const SideDrawerItems = ({closeSideDrawer}) => {
    const {pathname} = useLocation()
    const drawerNavLinks = getNavLinks();

    return (
        <React.Fragment>
            <div className="rtl w-100 text-center" style={{minHeight:'136px'}}>
                <img  src={brand} alt="" className="img-fluid my-4" />
            </div>
            <form className=" formDrawer text-center" onSubmit={e => e.preventDefault()}>
                <button 
                    className=" searchButton" 
                    type="submit"
                >
                    <i className="fa fa-search "></i>
                </button>
                <input 
                    className=" form-control searchInput" 
                    type="search" 
                    placeholder="جستجو کنید ..." 
                    aria-label="Search" />
            </form>
            <h6 className="rtl mt-5 mb-2 pb-3 mx-auto items-title">
                خدمات ما
            </h6>
            <ul className="rtl nav-links">
                {
                    drawerNavLinks.menu.map((item, index) => 
                        <li className="w-100" key={item.id}>
                            <div className="w-100 d-flex">
                                <span>
                                    <i className="fa fa-chevron-left felesh-item mr-3"></i>
                                    <NavLink 
                                        to= {{
                                            pathname: `${item.link}`,
                                            filter: ''
                                        }} 
                                        
                                        exact 
                                        className={pathname === item.link ? "sideDrawerItem active" : "sideDrawerItem"}
                                        onClick={closeSideDrawer}
                                    >
                                    <i className={`${item.icon} mr-2`}></i>
                                    {item.name}
                                    </NavLink> 
                                </span>
                            </div>
                        </li>
                    )
                }
            </ul>
        </React.Fragment>
    );
};

export default SideDrawerItems;
